module.exports = __webpack_public_path__ + "static/img/electric.e427a8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/electric.png
// module id = R49X
// module chunks = 0